var acc = document.getElementsByClassName("accordion");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    }
  });
}

class ProductCard extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.addEventListener("click", (event) => {
      // Real links (title link, cart button) handle navigation natively, incl. ctrl/middle click
      if (
        event.target.closest("a") ||
        event.target.closest(".addcart_btn") ||
        event.target.closest(".addcompare_btn")
      ) {
        return;
      }
      window.location.href = this.dataset.productUrl;
    });
  }
}
customElements.define("product-card", ProductCard);

class PriceSlider extends HTMLElement {
  constructor() {
    super();
    this.priceSlider = null;
    this.minInput = null;
    this.maxInput = null;
    this.hiddenMinInput = null;
    this.hiddenMaxInput = null;
    this.rangeText = null;
    this.rangeMin = 0;
    this.rangeMax = 0;
    this.currentMin = 0;
    this.currentMax = 0;
    this.updateTimeout = null;
    this.lastSubmittedMin = 0;
    this.lastSubmittedMax = 0;
  }

  connectedCallback() {
    this.priceSlider = this.querySelector('.filter-price-sliderr');
    this.minInput = this.querySelector('.price-input.min-price');
    this.maxInput = this.querySelector('.price-input.max-price');
    this.hiddenMinInput = this.querySelector('.filter-price--min');
    this.hiddenMaxInput = this.querySelector('.filter-price--max');
    this.rangeText = this.querySelector('.filter-price-range');

    this.rangeMin = parseFloat(this.priceSlider.dataset.rangemin) || 0;
    this.rangeMax = parseFloat(this.priceSlider.dataset.rangemax) || 1000;
    
    this.currentMin = this.minInput.value ? 
      Math.max(this.rangeMin, parseFloat(this.minInput.value)) : this.rangeMin;
    this.currentMax = this.maxInput.value ? 
      Math.min(this.rangeMax, parseFloat(this.maxInput.value)) : this.rangeMax;
    
    if (this.currentMin > this.currentMax) {
      this.currentMin = this.rangeMin;
      this.currentMax = this.rangeMax;
    }
    
    this.lastSubmittedMin = this.currentMin;
    this.lastSubmittedMax = this.currentMax;

    this.minInput.value = Math.round(this.currentMin);
    this.maxInput.value = Math.round(this.currentMax);
    this.updateRangeText();

    if (typeof noUiSlider === 'object') {
      this.initializeSlider();
    }

    this.setupEventListeners();
  }

  initializeSlider() {
    noUiSlider.create(this.priceSlider, {
      start: [this.currentMin, this.currentMax],
      connect: true,
      step: 1,
      range: {
        'min': this.rangeMin,
        'max': this.rangeMax
      }
    });

    this.priceSlider.noUiSlider.on('update', (values, handle) => {
      const newMin = Math.round(values[0]);
      const newMax = Math.round(values[1]);

      if (handle === 0 && newMin !== this.currentMin) {
        this.currentMin = newMin;
        this.minInput.value = this.currentMin;
      } else if (handle === 1 && newMax !== this.currentMax) {
        this.currentMax = newMax;
        this.maxInput.value = this.currentMax;
      }

      this.updateRangeText();
      this.updateHiddenInputs();
    });
  }

  setupEventListeners() {
    this.minInput.addEventListener('change', () => this.handleInputChange());
    this.maxInput.addEventListener('change', () => this.handleInputChange());
    
    this.minInput.addEventListener('keyup', (e) => {
      if (e.key === 'Enter') this.handleInputChange();
    });
    
    this.maxInput.addEventListener('keyup', (e) => {
      if (e.key === 'Enter') this.handleInputChange();
    });
  }

  handleInputChange() {
    let newMin = parseInt(this.minInput.value) || this.rangeMin;
    let newMax = parseInt(this.maxInput.value) || this.rangeMax;

    newMin = Math.max(this.rangeMin, Math.min(newMin, this.rangeMax));
    newMax = Math.min(this.rangeMax, Math.max(newMax, this.rangeMin));

    if (newMin > newMax) {
      if (document.activeElement === this.minInput) {
        newMin = this.currentMin;
        this.minInput.value = this.currentMin;
      } else {
        newMax = this.currentMax;
        this.maxInput.value = this.currentMax;
      }
      return;
    }

    this.currentMin = newMin;
    this.currentMax = newMax;

    if (this.priceSlider.noUiSlider) {
      this.priceSlider.noUiSlider.set([this.currentMin, this.currentMax]);
    }

    this.updateRangeText();
    this.updateHiddenInputs();
  }

  updateRangeText() {
    if (this.rangeText) {
      this.rangeText.textContent = `${this.currentMin} - ${this.currentMax}`;
    }
  }

  updateHiddenInputs() {
    this.hiddenMinInput.value = this.currentMin;
    this.hiddenMaxInput.value = this.currentMax;

    clearTimeout(this.updateTimeout);
    this.updateTimeout = setTimeout(() => {
      if (this.currentMin !== this.lastSubmittedMin || this.currentMax !== this.lastSubmittedMax) {
        this.lastSubmittedMin = this.currentMin;
        this.lastSubmittedMax = this.currentMax;
        this.dispatchFormUpdate();
      }
    }, 1000);
  }

  dispatchFormUpdate() {
    const event = new Event('input', {
      bubbles: true,
      cancelable: true,
    });
    const form = this.closest('form');
    if (form) {
      form.dispatchEvent(event);
    }
  }

  disconnectedCallback() {
    if (this.priceSlider && this.priceSlider.noUiSlider) {
      this.priceSlider.noUiSlider.destroy();
    }
  }
}

customElements.define('price-slider', PriceSlider);

document.addEventListener("DOMContentLoaded", () => {
  function updateBackgroundHeight() {
    let maxBottomPosition = 0;
    const bgImage = document.querySelector(".absolute_bg_top");
    
    if (!bgImage) {
      return;
    }
    
    document.querySelectorAll(".triger-bg--js").forEach(el => {
      const rect = el.getBoundingClientRect();
      const bottomPosition = rect.top + window.scrollY + rect.height;
      if (bottomPosition > maxBottomPosition) {
        maxBottomPosition = bottomPosition;
      }
    });
    let firstEl = document.querySelectorAll(".triger-bg--js")[0]
    if(maxBottomPosition == firstEl.getBoundingClientRect().top + window.scrollY + firstEl.getBoundingClientRect().height){
      maxBottomPosition += 20
    }
    
    bgImage.style.height = maxBottomPosition + 'px';
  }
  function triggerCollectionFiltersOverlay() {
    if (window.innerWidth <= 991) {
      const collectionFiltersDropdown = document.querySelectorAll('.collection-page--filters-drop');
      const header = document.querySelector('.cstm-header');
      if (collectionFiltersDropdown && header) {
        collectionFiltersDropdown.forEach(dropdown => {
          dropdown.addEventListener('click', () => {
            setTimeout(() => {
              header.style.zIndex = dropdown.open ? '0' : '2'
            }, 1);
          });
        });
      }
    }
  }

  triggerCollectionFiltersOverlay();
  updateBackgroundHeight();
  window.addEventListener("resize",() => {
    updateBackgroundHeight();
    triggerCollectionFiltersOverlay();
  });
  window.addEventListener("load", updateBackgroundHeight);
});